// source: pbtypes/gen/joysticks/rates.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = globalThis;

goog.exportSymbol('proto.joysticks.Rates', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.joysticks.Rates = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.joysticks.Rates, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.joysticks.Rates.displayName = 'proto.joysticks.Rates';
}



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.joysticks.Rates.prototype.toObject = function(opt_includeInstance) {
  return proto.joysticks.Rates.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.joysticks.Rates} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.joysticks.Rates.toObject = function(includeInstance, msg) {
  var f, obj = {
ascendSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 1, 0.0),
descendSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 2, 0.0),
forwardSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 3, 0.0),
lateralSpeed: jspb.Message.getFloatingPointFieldWithDefault(msg, 4, 0.0),
headingRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 5, 0.0),
gimbalPitchRate: jspb.Message.getFloatingPointFieldWithDefault(msg, 6, 0.0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.binary.bytesource.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.joysticks.Rates}
 */
proto.joysticks.Rates.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.joysticks.Rates;
  return proto.joysticks.Rates.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.joysticks.Rates} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.joysticks.Rates}
 */
proto.joysticks.Rates.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setAscendSpeed(value);
      break;
    case 2:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setDescendSpeed(value);
      break;
    case 3:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setForwardSpeed(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setLateralSpeed(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setHeadingRate(value);
      break;
    case 6:
      var value = /** @type {number} */ (reader.readFloat());
      msg.setGimbalPitchRate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.joysticks.Rates.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.joysticks.Rates.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.joysticks.Rates} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.joysticks.Rates.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAscendSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      1,
      f
    );
  }
  f = message.getDescendSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      2,
      f
    );
  }
  f = message.getForwardSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      3,
      f
    );
  }
  f = message.getLateralSpeed();
  if (f !== 0.0) {
    writer.writeFloat(
      4,
      f
    );
  }
  f = message.getHeadingRate();
  if (f !== 0.0) {
    writer.writeFloat(
      5,
      f
    );
  }
  f = message.getGimbalPitchRate();
  if (f !== 0.0) {
    writer.writeFloat(
      6,
      f
    );
  }
};


/**
 * optional float ascend_speed = 1;
 * @return {number}
 */
proto.joysticks.Rates.prototype.getAscendSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 1, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.joysticks.Rates} returns this
 */
proto.joysticks.Rates.prototype.setAscendSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 1, value);
};


/**
 * optional float descend_speed = 2;
 * @return {number}
 */
proto.joysticks.Rates.prototype.getDescendSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 2, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.joysticks.Rates} returns this
 */
proto.joysticks.Rates.prototype.setDescendSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 2, value);
};


/**
 * optional float forward_speed = 3;
 * @return {number}
 */
proto.joysticks.Rates.prototype.getForwardSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 3, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.joysticks.Rates} returns this
 */
proto.joysticks.Rates.prototype.setForwardSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 3, value);
};


/**
 * optional float lateral_speed = 4;
 * @return {number}
 */
proto.joysticks.Rates.prototype.getLateralSpeed = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 4, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.joysticks.Rates} returns this
 */
proto.joysticks.Rates.prototype.setLateralSpeed = function(value) {
  return jspb.Message.setProto3FloatField(this, 4, value);
};


/**
 * optional float heading_rate = 5;
 * @return {number}
 */
proto.joysticks.Rates.prototype.getHeadingRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 5, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.joysticks.Rates} returns this
 */
proto.joysticks.Rates.prototype.setHeadingRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 5, value);
};


/**
 * optional float gimbal_pitch_rate = 6;
 * @return {number}
 */
proto.joysticks.Rates.prototype.getGimbalPitchRate = function() {
  return /** @type {number} */ (jspb.Message.getFloatingPointFieldWithDefault(this, 6, 0.0));
};


/**
 * @param {number} value
 * @return {!proto.joysticks.Rates} returns this
 */
proto.joysticks.Rates.prototype.setGimbalPitchRate = function(value) {
  return jspb.Message.setProto3FloatField(this, 6, value);
};


goog.object.extend(exports, proto.joysticks);
